import { render } from "./InputMultiplaEscolha.vue?vue&type=template&id=679636de&scoped=true"
import script from "./InputMultiplaEscolha.vue?vue&type=script&lang=js"
export * from "./InputMultiplaEscolha.vue?vue&type=script&lang=js"

import "./InputMultiplaEscolha.vue?vue&type=style&index=0&id=679636de&lang=scss&scoped=true"
import "./InputMultiplaEscolha.vue?vue&type=style&index=1&id=679636de&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679636de"],['__file',"src/components/CampoForm/components/InputMultiplaEscolha.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "679636de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('679636de', __exports__)) {
    console.log('reload')
    api.reload('679636de', __exports__)
  }
  
  module.hot.accept("./InputMultiplaEscolha.vue?vue&type=template&id=679636de&scoped=true", () => {
    console.log('re-render')
    api.rerender('679636de', render)
  })

}


export default __exports__